import React, { useState, useEffect } from "react";
import logo from "../images/new_logo.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";


const Navbar = ({ value, setValue, click, setClick }) => {
  const [navBar, setNavBar] = useState({ windowPosition: window.pageYOffset });

  const handleScroll = () => {
    setNavBar({ windowPosition: window.pageYOffset });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);
  return (
    <motion.nav
      exit={{ opacity: 0, x: "-100vw", transition: "easeInOut" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      onScroll={handleScroll}
      className={
        navBar.windowPosition > 100 ? "navbar-fixed nav nav-bg " : "nav"
      }
      id="nav"
    >
      <div className="nav-center">
        <div className="nav-header">
          <Link exact to="/">
            <motion.img
              initial={{ rotateY: 0 }}
              animate={{ rotateY: 360 }}
              transition={{
                ease: "easeInOut",
                duration: 2,
                flip: Infinity,
                repeatDelay: 5,
              }}
              src={logo}
              className="nav-logo"
              alt="logo"
            />
          </Link>
          <motion.button
            className="nav-btn"
            id="nav-btn"
            onClick={() => {
              setClick(!click);
              setValue(!value);
            }}
          >
            <i className="fas fa-bars"></i>
          </motion.button>
        </div>
        <ul className="nav-links hero-icon">
          <li>
            <Link to="/" id="Home" className="a">
              Home
            </Link>
          </li>
          <li>
            <Link to="/projects" className="a">
              Projects
            </Link>
          </li>
          <li>
            <Link to="/education" id="contact" className="a">
              Education
            </Link>
          </li>

          <li>
            <Link to="/about" id="contact" className="a">
              About
            </Link>
          </li>
          <li>
            <Link to="/contact" id="contact" className="a">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </motion.nav>
  );
};
export default Navbar;
